import Image from 'next/image';
import { JobPosition } from '../types';

export default function JobCard({
  imageUrl,
  company,
  position,
  salary,
  description
}: JobPosition) {
  return (
    <div className="inline-flex max-w-[205px] flex-col items-center justify-start rounded bg-white pb-[10px]">
      <div className=" flex flex-col items-center justify-start gap-2 ">
        <div className="inline-flex h-[76px] items-center justify-center overflow-hidden bg-white">
          <Image
            src={imageUrl}
            alt={`${company}のロゴ`}
            width={200}
            height={120}
            className="h-full w-auto object-contain "
          />
        </div>
      </div>
      <div className="mb-[6px] w-full border-t border-[#E2E2E2]"></div>
      <div className="flex flex-col items-center justify-start gap-3 self-stretch rounded-bl rounded-br bg-white px-4 pt-3.5">
        <div className="flex h-[54px] flex-col items-start justify-start gap-2 self-stretch">
          <div className="text-[10px] font-semibold leading-3 text-[#6e6e6e]">
            {company}
          </div>
          <div className="inline-flex items-center justify-center gap-2.5 self-stretch">
            <div className="flex h-[34px] shrink grow basis-0 items-center whitespace-pre-line text-base font-semibold leading-tight text-[#242424]">
              {position}
            </div>
          </div>
        </div>
        <div className="flex h-[99px] flex-col items-start justify-start gap-2 self-stretch">
          <div className="inline-flex items-center justify-start gap-[9px]">
            <div className="flex items-center justify-center gap-2.5 bg-[#d70c18] px-[6px] py-[2px]">
              <div className="text-[10px] font-semibold leading-[15px] text-white">
                年収
              </div>
            </div>
            <div className="justify-start">
              {/* 万円が含まれている場合は、万円を小さいフォントで表示し、それ以外はそのまま表示 */}
              {salary.includes('万円') ? (
                <>
                  {salary.split(/(万円)/).map((part, index) =>
                    part === '万円' ? (
                      <span
                        key={index}
                        className="text-[10px] font-semibold leading-[10px] tracking-tight text-neutral-800"
                      >
                        {part}
                      </span>
                    ) : (
                      <span
                        key={index}
                        className="text-sm font-semibold leading-none tracking-tight text-neutral-800"
                      >
                        {part}
                      </span>
                    )
                  )}
                </>
              ) : (
                <span className="text-sm font-semibold leading-[14px] text-[#242424]">
                  {salary}
                </span>
              )}
            </div>
          </div>
          <div className="self-stretch overflow-hidden whitespace-pre-line text-xs font-normal leading-tight text-[#3e3939]">
            {description}
          </div>
        </div>
      </div>
    </div>
  );
}
